import React__default from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { AutoExpand } from '../AutoExpand/index.js';
import { getAttributesConfigurable, getSelectedConfigurable } from './configurable-helpers.js';
export { getAttributesConfigurable, getSelectedConfigurable } from './configurable-helpers.js';
import styles from 'ui-components/AddToCart.scss';
import { ConfigurableConfigurations, BundleConfigurations, CustomOptionsInputConfigurations, CustomOptionsChoiceConfigurations } from './configurations.js';
import { useAddToCartSimple, useAddToCartConfig, useAddToCartBundle, useAddToCartCustomOptions } from './add-to-cart-hooks.js';

var AddToCartSimple = function AddToCartSimple(_ref) {
  var product = _ref.product,
    qty = _ref.qty,
    onAdd = _ref.onAdd,
    children = _ref.children;
  var addToCart = useAddToCartSimple(product);
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      addToCart(qty);
      if (typeof onAdd === "function") {
        onAdd(product);
      }
    }
  }, /*#__PURE__*/React__default.createElement(AutoExpand, null, children));
};
var AddToCartConfig = function AddToCartConfig(_ref2) {
  var product = _ref2.product,
    selected = _ref2.selected,
    setSelected = _ref2.setSelected,
    templates = _ref2.templates,
    qty = _ref2.qty,
    onAdd = _ref2.onAdd,
    children = _ref2.children;
  var addToCart = useAddToCartConfig(product);
  var configAttributes = getAttributesConfigurable(product);
  var selectedItem = getSelectedConfigurable(selected, configAttributes);
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      addToCart(selectedItem, qty);
      if (typeof onAdd === "function") {
        onAdd(product);
      }
    }
  }, /*#__PURE__*/React__default.createElement(AutoExpand, null, product.options.items.length > 0 && /*#__PURE__*/React__default.createElement(ConfigurableConfigurations, {
    selected: selected,
    select: setSelected,
    configAttributes: configAttributes,
    selectedItemConfigurable: selectedItem,
    templates: templates
  }), children));
};
var AddToCartBundle = function AddToCartBundle(_ref3) {
  var product = _ref3.product,
    selected = _ref3.selected,
    setSelected = _ref3.setSelected,
    templates = _ref3.templates,
    qty = _ref3.qty,
    onAdd = _ref3.onAdd,
    children = _ref3.children;
  var addToCart = useAddToCartBundle(product);
  if (!product.bundleOptions) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      addToCart(selected, qty);
      if (typeof onAdd === "function") {
        onAdd(product);
      }
    }
  }, /*#__PURE__*/React__default.createElement(AutoExpand, null, /*#__PURE__*/React__default.createElement(BundleConfigurations, {
    selected: selected,
    select: setSelected,
    bundleAttributes: product.bundleOptions,
    product: product,
    templates: templates
  }), children));
};
var AddToCartCustomOptions = function AddToCartCustomOptions(_ref4) {
  var product = _ref4.product,
    selected = _ref4.selected,
    setSelected = _ref4.setSelected,
    fieldVariant = _ref4.fieldVariant,
    qty = _ref4.qty,
    onAdd = _ref4.onAdd,
    children = _ref4.children;
  var addToCart = useAddToCartCustomOptions(product);
  var customOptions = product.customOptions || null;
  var _React$useState = React__default.useState({}),
    textValues = _React$useState[0],
    setTextValues = _React$useState[1];
  var _React$useState2 = React__default.useState({}),
    errorValues = _React$useState2[0],
    setErrorValues = _React$useState2[1];
  var _React$useState3 = React__default.useState({}),
    selectedItem = _React$useState3[0],
    setSelectedItem = _React$useState3[1];
  if (!customOptions || customOptions.length === 0) {
    return null;
  }
  var options = customOptions;
  var optionsList = options.map(function (option, index) {
    switch (option.type) {
      case "multiple":
        // TODO: add functionality for multiple later (not supported yet)
        return null;
      case "drop_down":
        if (option.values === null) {
          return null;
        }
        var selectedConfigValue = selected[options[index].title];
        var currSelectedItem = option.values.find(function (x) {
          return x.id === selectedConfigValue;
        });
        var currSelectedItemId = currSelectedItem ? currSelectedItem.id : null;
        if (selectedItem[option.id] !== currSelectedItemId) {
          setSelectedItem(function (prev) {
            var _extends2;
            return _extends({}, prev, (_extends2 = {}, _extends2[option.id] = currSelectedItemId, _extends2));
          });
        }
        return /*#__PURE__*/React__default.createElement(CustomOptionsChoiceConfigurations, {
          key: index,
          option: option,
          selected: selected,
          setSelected: setSelected,
          selectedItemConfigurable: selectedItem
        });
      case "field":
      case "area":
        return /*#__PURE__*/React__default.createElement(CustomOptionsInputConfigurations, {
          key: index,
          option: option,
          fieldVariant: fieldVariant,
          textValues: textValues,
          setTextValues: setTextValues,
          errorValues: errorValues,
          setErrorValues: setErrorValues
        });
      default:
        return null;
    }
  });
  var generateOptionArray = function generateOptionArray() {
    var textOptionArray = Object.keys(textValues).map(function (key) {
      return {
        optionId: key,
        value: {
          text: textValues[key]
        }
      };
    });
    var selectOptionArray = Object.keys(selectedItem).map(function (key) {
      return {
        optionId: key,
        value: {
          selectionId: selectedItem[key]
        }
      };
    });
    var arr = [].concat(textOptionArray, selectOptionArray);
    return arr;
  };
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var customOptionsSelect = generateOptionArray();
      addToCart(customOptionsSelect, qty);
      if (typeof onAdd === "function") {
        onAdd(product);
      }
    }
  }, /*#__PURE__*/React__default.createElement(AutoExpand, {
    className: styles.customOptions
  }, optionsList, children));
};
var AddToCart = function AddToCart(_ref5) {
  var product = _ref5.product,
    onAdd = _ref5.onAdd,
    selected = _ref5.selected,
    setSelected = _ref5.setSelected,
    templates = _ref5.templates,
    customFieldVariant = _ref5.customFieldVariant,
    children = _ref5.children,
    _ref5$qty = _ref5.qty,
    qty = _ref5$qty === void 0 ? 1 : _ref5$qty;
  switch (product.type) {
    case "bundle":
      return /*#__PURE__*/React__default.createElement(AddToCartBundle, {
        product: product,
        selected: selected,
        setSelected: setSelected,
        templates: templates,
        qty: qty,
        onAdd: onAdd
      }, children);
    case "configurable":
      return /*#__PURE__*/React__default.createElement(AddToCartConfig, {
        product: product,
        selected: selected,
        setSelected: setSelected,
        templates: templates,
        qty: qty,
        onAdd: onAdd
      }, children);
    case "simple":
    case "virtual":
    default:
      if (product.customOptions) {
        return /*#__PURE__*/React__default.createElement(AddToCartCustomOptions, {
          selected: selected,
          setSelected: setSelected,
          fieldVariant: customFieldVariant,
          product: product,
          qty: qty,
          onAdd: onAdd
        }, children);
      }
      return /*#__PURE__*/React__default.createElement(AddToCartSimple, {
        product: product,
        qty: qty,
        onAdd: onAdd
      }, children);
  }
};
var getPrice = function getPrice(product, selected, type) {
  var configAttributes = product.type === "configurable" ? getAttributesConfigurable(product) : {};
  var item = getSelectedConfigurable(selected, configAttributes);
  switch (product.type) {
    case "configurable":
      if (item) {
        var selectedOption = product.options.items.find(function (x) {
          return x.buyRequest === item.buyRequest;
        });
        if (selectedOption) {
          return selectedOption.price[type];
        }
      }
      break;
    case "bundle":
      var price = product.price[type];
      product.bundleOptions.forEach(function (option) {
        option.selections.forEach(function (selection) {
          if (selected[option.optionId] === selection.selectionId) {
            price += selection.price[type];
          }
        });
      });
      return price;
  }
  return product.price[type];
};
var inStock = function inStock(product, selected) {
  switch (product.type) {
    case "simple":
    case "virtual":
      return Boolean(product.buyRequest);
    case "configurable":
      if (product.options.items.length === 0) {
        return false;
      }

      // Configurables can only have one option.
      // No need to loop through selected
      var _key = Object.keys(selected)[0];
      if (!_key) {
        return true;
      }
      for (var i = 0; i < product.options.items.length; i++) {
        if (product.options.items[i].buyRequest === selected[_key]) {
          return selected[_key] !== null;
        }
      }
      return false;
    case "bundle":
      // @TODO: handle bundle case
      return true;
    default:
      return false;
  }
};
var productDefaults = function productDefaults(product) {
  return function () {
    var d = {};
    // Pre-select the defaults if bundle with defaults
    if (product.type === "bundle") {
      product.bundleOptions.forEach(function (o) {
        o.selections.forEach(function (s) {
          if (s.isDefault) {
            d[o.optionId] = s.selectionId;
          }
        });
      });
    }
    if (product.type === "configurable") {
      var configAttributes = getAttributesConfigurable(product);
      Object.keys(configAttributes).forEach(function (attributeKey) {
        var attribute = configAttributes[attributeKey];
        if (attribute.items.length > 0) {
          d[attribute.name] = attribute.items[0].buyRequest;
        }
      });
    }
    return d;
  };
};

export { AddToCart, getPrice, inStock, productDefaults };
//# sourceMappingURL=index.js.map
